import { ChangeDetectionStrategy, Component } from '@angular/core';
import { KENDO_CARD } from '@progress/kendo-angular-layout';

// Coquille de carte générique construite autour de kendo-card : fond, bords arrondis et ombre portée.
// Tout contenu (en-tête, corps, surcouches métier) est projeté via <ng-content>.
@Component({
  selector: 'val-carte',
  imports: [KENDO_CARD],
  templateUrl: './carte.component.html',
  styleUrls: ['./carte.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ValCarteComponent {
}
